import React from 'react';
import Fade from 'react-reveal/Fade';

const Title = ({ title }) => (
  <header className="major">
    <h2 style={{ marginBottom: -5 }}>{title}</h2>
  </header>
);

const Sobre = () => (
  <Fade left>
    <div className="wrapper" id="sobre">
      <div className="container">
        <Title title="Sobre" />
        <section>
          <h3>1º Hackathon AgriTech - UniLasalle/Lucas</h3>
          <p>
            É um evento proposto pela UniLasalle/Lucas o qual tem
            como objetivo reunir pessoas para o desenvolvimento de soluções específicas e de
            aplicabilidade para a agricultura e agronegócio. O evento reunirá acadêmicos e
            profissionais como técnicos, agricultores, engenheiros agrônomos, programadores,
            engenheiros agrícolas e outros profissionais ligados ao desenvolvimento do tema central do
            evento. Estes profissionais irão formar times para a maratona de atividades (discussões,
            elaboração de estratégias e apresentação de um produto final), sendo o produto final capaz
            de solucionar ou direcionar para a resolução do problema exposto sugerido no início das
            atividades.
          </p>
        </section>
        <Title title="Equipes" />
        <section>
          <p>
            As equipes devem ser composta por profissionais com conhecimento multidisciplinar e terão suporte
            de um grupo mentores que estarão disponíveis durante o evento para auxiliar na viabilidade técnica
            e na apresentação do modelo de negócio que poderá se transformar em produto. O produto a ser entregue
            ao final do evento deverá ser um produto mínimo viável (MVP).
          </p>
          <hr />
          <h4>Atenção! Não esqueça de trazer no dia:</h4>
          <ul>
            <li>Notebook (essencial), extensões, filtros de linha, adaptadores, carregadores e afins (serão disponibilizados três tomadas por mesa/equipe).</li>
            <li>Se quiser dormir no local trazer seu colchão/colchonete. Também haverá um local para tomar banho.</li>
          </ul>
          <p>
            <span style={{ color: '#fff', fontWeight: 'bold' }}>Alimentação:</span> durante o evento será fornecido café da manhã, almoço e janta para os participantes.
            Toda a alimentação deverá ser consumida no próprio local do evento.</p>
          <hr />
        </section>
      </div>
    </div>
  </Fade>
);

export default Sobre;
